import { Call } from './call';

import image1 from './assets/calls/1/image.png';
import audio1 from './assets/calls/1/joke.wav';

import image2 from './assets/calls/2/image.png';
import audio2 from './assets/calls/2/burp5.wav';

import image3 from './assets/calls/3/image.png';
import audio3 from './assets/calls/3/burp3.wav';

import image4 from './assets/calls/4/image.png';
import audio4 from './assets/calls/4/MIHAJESKONASRAL.mp3';

import image5 from './assets/calls/5/image.png';
import audio5 from './assets/calls/5/burp1.wav';

import image6 from './assets/calls/6/image.png';
import audio6 from './assets/calls/6/burp.mp3';

import image7 from './assets/calls/7/image.png';
import audio7 from './assets/calls/7/audio.ogg';

import image8 from './assets/calls/8/image.png';
import audio8 from './assets/calls/8/audio.mp3';


export const calls: Call[] = [
    {
        id: 'roma-default',
        personName: 'Рома',
        image: image1,
        audio: audio1,
    },
    {
        id: 'baretskiy',
        personName: 'Рома Барецкий',
        image: image2,
        audio: audio2,
    },
    {
        id: 'rambo',
        personName: 'Рома Рэмбо',
        image: image3,
        audio: audio3,
        forAdvertisement: true,
    },
    {
        id: 'miha',
        personName: 'Миха',
        image: image4,
        audio: audio4,
        forAdvertisement: true,
    },
    {
        id: 'shaylushay',
        personName: 'Рома Шайлушай',
        image: image5,
        audio: audio5,
    },
    {
        id: 'danya',
        personName: 'Даня',
        image: image6,
        audio: audio6,
        forAdvertisement: true,
    },
    {
        id: 'egor',
        personName: 'Егор',
        image: image7,
        audio: audio7,
        forAdvertisement: true,
    },
];

export const rewardedCalls = calls.filter(call => call.forAdvertisement);
export const freeCalls = calls.filter(call => !call.forAdvertisement);
freeCalls.forEach(call => call.available = true);

export const randomCall: Call = {
    id: 'developer',
    personName: 'Разработчик',
    image: image8,
    audio: audio8,
    available: false,
};
